import React from 'react'
import UserMenuView from './UserMenuView'
import { useHistory } from 'react-router'
import routesConfig from 'routesConfig'
import {ACCESS_TOKEN} from "../../constants";
import {connect} from "react-redux";
import {selectUserRidesSummary} from "../../store/ride/reducer";
import {
    selectActiveSubscriptionName,
    selectRidesSummary,
    selectUserFirstName,
    selectWalletBalance
} from "../../store/user/reducer";

function UserMenuContainer(props) {
    const history = useHistory()
    const onCredit = () => history.push(routesConfig.Credit)
    const onGift = () => history.push(routesConfig.Gift)
    const onSetting = () => history.push(routesConfig.Setting)
    const onSubscription = () => {history.push(routesConfig.subscription)}
    const onTrips = () => {
        history.push(routesConfig.trips)
    }
    const onPayments = () => {
        history.push(routesConfig.payments)
    }
    const onGuide = () => {
        history.push(routesConfig.rideGuide)
    }
    const onLogout = () => {localStorage.removeItem(ACCESS_TOKEN); history.push(routesConfig.home);};
    return <UserMenuView
        {...props}
        onCredit={onCredit}
        onGift={onGift}
        onSetting={onSetting}
        onSubscription={onSubscription}
        onLogout={onLogout}
        onTrips={onTrips}
        onGuide={onGuide}
        onPayments={onPayments}
    />
}

const mapStateToProps = state => ({
    ridesSummary: selectRidesSummary(state),
    userFirstName: selectUserFirstName(state),
    activeSubscriptionName: selectActiveSubscriptionName(state),
    walletBalance: selectWalletBalance(state),
})

export default connect(mapStateToProps)(UserMenuContainer)